import apiClient, { getCsrfCookie } from './client';

/**
 * Installed-module descriptor as returned by GET /api/admin/modules.
 */
export interface ModuleInfo {
  id: string;
  name: string;
  version: string | null;
  description: string | null;
  author: string | null;
  min_core_version: string | null;
  dependencies: string[];
  enabled: boolean;
  errored: boolean;
  error: string | null;
}

const MODULES_BASE = '/api/admin/modules';

export const modulesApi = {
  async list(): Promise<ModuleInfo[]> {
    const { data } = await apiClient.get<{ data: ModuleInfo[] }>(MODULES_BASE);
    return data.data;
  },

  async setEnabled(id: string, enabled: boolean): Promise<{ id: string; enabled: boolean }> {
    await getCsrfCookie();
    const { data } = await apiClient.patch<{ data: { id: string; enabled: boolean } }>(
      `${MODULES_BASE}/${id}`,
      { enabled }
    );
    return data.data;
  },
};
